interface NumberViewerProps {
  value: number;
}

export function NumberViewer({ value }: NumberViewerProps) {
  const formatted = new Intl.NumberFormat().format(value);
  return <span className='text-neutral-950 font-mono text-sm'>{formatted}</span>;
}
